/**
 * Kept for existing callers (case studies); delegates to the shared
 * DOMPurify sanitizer, which keeps structural, image and maths markup.
 */
import { sanitizeHtml } from './sanitizeHtml';

export function stripDangerousHtml(html) {
  return sanitizeHtml(html);
}
